<template>
<div id="app">
  <div class="loading">
  <div class="loadbox"> <img src="../src/assets/picture/loading.gif"> 页面加载中... </div>
</div>
<div class="head">
  <h1>南康区乡镇综合文化站人流统计智慧系统</h1>
  <div class="weather"><!--<img src="picture/weather.png"><span>乡云转小雨</span>--><span id="showTime"></span></div>
	

	
	
</div>
<div class="mainbox">
  <ul class="clearfix">
    <li>
      <div class="boxall" style="height: 3.2rem">
        <div class="alltitle">今日核心指标</div>
        <div class="allnav" id="echart1"></div>
        <div class="boxfoot"></div>
      </div>
      <div class="boxall" style="height: 3.2rem">
        <div class="alltitle">进入人流</div>
        <div class="allnav" id="echart2"></div>
        <div class="boxfoot"></div>
      </div>
      <div class="boxall" style="height: 3.2rem">
        <div style="height:100%; width: 100%;">
		  	<div class="sy" id="fb1"></div>
				<div class="sy" id="fb2"></div>
				<div class="sy" id="fb3"></div>
		  </div>
        <div class="boxfoot">
			
		  </div>
      </div>
    </li>
    <li>
      <div class="bar">
        <div class="barbox">
          <ul class="clearfix">
            <li class="pulll_left counter">{{incount}}</li>
            <li class="pulll_left counter">{{outcount}}</li>
          </ul>
        </div>
        <div class="barbox2">
          <ul class="clearfix">
            <li class="pulll_left">今日进馆人流 </li>
            <li class="pulll_left">近30天进馆人流</li>
          </ul>
        </div>
      </div>
      <div  >
      </div>
      <div class="map" id="main" >
        <div class="map1"><img src="picture/lbx.png"></div>
        <div class="map2"><img src="picture/jt.png"></div>
        <div class="map3"><img src="picture/map.png"></div>
        <div class="map4" id="map_1"></div>
      </div>
    </li>
    <li>
          <div class="boxall" style="height:3.4rem">
        <div class="alltitle">近30天核心指标趋势</div>
        <div class="allnav" id="echart4"></div>
        <div class="boxfoot"></div>
      </div>
      <div class="boxall" style="height: 3.2rem">
        <div class="alltitle">进入人流</div>
        <div class="allnav" id="echart5"></div>
        <div class="boxfoot"></div>
      </div>
      <!-- <div class="boxall" style="height: 3rem">
        <div class="alltitle">模块标题样式</div>
        <div class="allnav" id="echart6"></div>
        <div class="boxfoot"></div>
        
      </div> -->
      <div class="boxall" style="height: 3.4rem">
        <div class="alltitle">各文化站人流统计</div>
        <div class="alltitle" style=" display: flex; justify-content: space-between;"> <div class="f_w">序号</div><div class="f_w">地点</div><div class="f_w">总人数</div></div>
        <div class="wrap">
              <ul>
            <li v-for="(item,index) in data" :key="item.name">
                  <p style="display: flex; justify-content: space-between;"><span class="f_w6">{{index + 1}}</span>{{item.name}}<span class="f_w6">{{item.value}}</span></p>
                </li>
          </ul>
            </div>
        <div class="boxfoot"></div>
      </div>
    </li>
  </ul>
</div>

  
</div>
</template>

<script>
// import _ from 'lodash'
import $ from "jquery"
import * as echarts from "echarts";



export default {
  data(){
    return {
              msg:"今日核心指标",
              ref:null,
              ref2:null,
              ref3:null,
              arrincount:[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,],
              data:[
            {
                name: '南水新区综合文化站',
                value:0,
            },{
                name: '东山街办综合文化站',
                value:0,
            },{
                name: '蓉江街办综合文化站',
                value:0,
            },
            {
                name: '龙岭镇综合文化站',
                value:0,
            },{
                name: '龙回镇综合文化站',
                value:0,
            },{
                name: '浮石乡综合文化站',
                value:0,
            },{
                name: '横寨乡综合文化站',
                value:0,
            },{
                name: '赤土畲族乡综合文化站',
                value:0,
            },{
                name: '朱坊乡综合文化站',
                value:0,
            },{
                name: '龙华镇综合文化站',
                value:0,
            },{
                name: '唐江镇综合文化站',
                value:0,
            },{
                name: '太窝乡综合文化站',
                value:0,
            },{
                name: '镜坝镇综合文化站',
                value:0,
            },{
                name: '麻双乡综合文化站',
                value:0,
            },{
                name: '横市镇综合文化站',
                value:0,
            },{
                name: '十八塘乡综合文化站',
                value:0,
            },{
                name: '大坪乡综合文化站',
                value:0,
            },{
                name: '坪市乡综合文化站',
                value:0,
            },{
                name: '隆木乡综合文化站',
                value:0,
            }
        ],
              tdrows:'',
              timenum:[0, 0, 0, 0, 0, 0, 0,0,0,0,0,0,0,],
              innum1:[0,0,0,0,0,0,0,0,0,],
              innum2:[0, 0, 0, 0, 0, 0, 0,0,0,0,],
              incount:0,
              outcount:0,
              time:[],
              timein:[],
              screenWidth: document.body.clientWidth, // 屏幕宽度
                timer: false ,
                cZjson:{"type":"FeatureCollection","features":[{"type":"Feature","properties":{"adcode":360703,"name":"南康区","center":[114.756933,25.661721],"centroid":[114.696299,25.832669],"childrenNum":0,"level":"district","acroutes":[100000,360000,360700],"parent":{"adcode":360700}},"geometry":{"type":"MultiPolygon","coordinates":[[[[114.795752,25.953703],[114.794285,25.955796],[114.792617,25.959973],[114.790308,25.961309],[114.787779,25.962258],[114.786745,25.964907],[114.785054,25.967956],[114.784865,25.970612],[114.78361,25.97194],[114.781919,25.972704],[114.778128,25.975175],[114.775909,25.980393],[114.778163,25.983535],[114.777329,25.987302],[114.776897,25.988051],[114.777176,25.98995],[114.77902,25.990382],[114.781136,25.991902],[114.783878,25.993037],[114.786835,25.993608],[114.789038,25.994511],[114.789974,25.996457],[114.788944,25.99692],[114.787815,26.000046],[114.787355,26.003519],[114.788542,26.008219],[114.790493,26.012742],[114.789125,26.013853],[114.783819,26.015666],[114.778808,26.017773],[114.777722,26.021717],[114.777939,26.024626],[114.777435,26.026324],[114.778348,26.027898],[114.780362,26.029055],[114.779665,26.032728],[114.77808,26.033986],[114.778607,26.035745],[114.783838,26.041817],[114.785652,26.044549],[114.786041,26.046223],[114.785565,26.051153],[114.786647,26.052542],[114.786257,26.054879],[114.78776,26.058196],[114.787543,26.060387],[114.786969,26.061282],[114.787933,26.067446],[114.786997,26.07111],[114.784708,26.073115],[114.782072,26.074643],[114.778423,26.075059],[114.77705,26.074411],[114.775516,26.072822],[114.773848,26.072035],[114.771638,26.073401],[114.768106,26.07273],[114.76435,26.073216],[114.762623,26.073686],[114.759536,26.075321],[114.758537,26.076671],[114.757703,26.083227],[114.755776,26.089706],[114.754977,26.091171],[114.753668,26.092344],[114.750022,26.093161],[114.748413,26.093863],[114.748181,26.095459],[114.748511,26.098791],[114.747398,26.10196],[114.747044,26.106942],[114.746148,26.108338],[114.741927,26.11109],[114.740338,26.112625],[114.737727,26.113165],[114.732704,26.116966],[114.732346,26.120228],[114.734356,26.127036],[114.734702,26.132078],[114.735111,26.135347],[114.736476,26.138361],[114.739273,26.140381],[114.739925,26.142],[114.739674,26.143657],[114.738934,26.145122],[114.735512,26.148976],[114.732948,26.151489],[114.725684,26.152044],[114.723965,26.152507],[114.715646,26.155998],[114.712846,26.158218],[114.710907,26.161086],[114.709719,26.162303],[114.709153,26.164238],[114.709397,26.164932],[114.705468,26.166843],[114.701118,26.168708],[114.698325,26.169348],[114.695206,26.172662],[114.692276,26.174874],[114.687611,26.179606],[114.685621,26.181956],[114.683517,26.182126],[114.680107,26.181571],[114.677043,26.181486],[114.67427,26.182665],[114.670373,26.183243],[114.667199,26.1851],[114.66655,26.187482],[114.66666,26.189724],[114.6676,26.192329],[114.668949,26.194347],[114.667494,26.19558],[114.664276,26.195603],[114.662357,26.196428],[114.657087,26.198],[114.653991,26.198501],[114.650632,26.196497],[114.647321,26.192829],[114.644571,26.191111],[114.641799,26.191342],[114.637932,26.199317],[114.636029,26.202338],[114.632611,26.203393],[114.626157,26.202446],[114.619388,26.202045],[114.614499,26.200018],[114.608639,26.200473],[114.606468,26.201575],[114.606538,26.206606],[114.607691,26.20995],[114.609622,26.213325],[114.610039,26.216137],[114.608745,26.22062],[114.607518,26.22317],[114.605705,26.224326],[114.598641,26.224703],[114.597366,26.228678],[114.596474,26.230712],[114.594519,26.232206],[114.587349,26.232306],[114.584816,26.233947],[114.583239,26.235749],[114.580489,26.236242],[114.57632,26.235565],[114.57326,26.234224],[114.570271,26.232545],[114.565316,26.228925],[114.561685,26.227754],[114.558448,26.228008],[114.554212,26.227453],[114.552226,26.226313],[114.549984,26.219103],[114.548195,26.215967],[114.545406,26.214118],[114.543086,26.21344],[114.541233,26.213679],[114.538091,26.21515],[114.536588,26.216599],[114.535558,26.219033],[114.534114,26.220204],[114.532911,26.220512],[114.530394,26.219295],[114.527365,26.218186],[114.524518,26.215875],[114.523853,26.213671],[114.520565,26.213764],[114.518465,26.21324],[114.519035,26.211969],[114.521587,26.210027],[114.522815,26.207492],[114.522331,26.204225],[114.522425,26.203077],[114.52154,26.200604],[114.5204,26.198863],[114.519959,26.196906],[114.520305,26.194162],[114.520038,26.192729],[114.516282,26.19155],[114.515955,26.189886],[114.513764,26.185362],[114.511275,26.182095],[114.509076,26.179929],[114.505375,26.176924],[114.503318,26.174119],[114.502331,26.171467],[114.499873,26.171236],[114.495428,26.169864],[114.493576,26.168277],[114.494111,26.165656],[114.494347,26.160454],[114.494382,26.153871],[114.493733,26.150533],[114.491881,26.147512],[114.490591,26.144228],[114.491578,26.139271],[114.493072,26.136102],[114.493446,26.134445],[114.494768,26.131484],[114.494351,26.128709],[114.495279,26.126673],[114.498087,26.125856],[114.501619,26.126342],[114.504703,26.128154],[114.506323,26.127668],[114.507377,26.12591],[114.507448,26.1247],[114.508494,26.123266],[114.510032,26.122441],[114.511865,26.122425],[114.515385,26.121253],[114.517304,26.118439],[114.518681,26.117097],[114.522071,26.115987],[114.527747,26.11446],[114.529052,26.11335],[114.529544,26.109818],[114.531094,26.109047],[114.532868,26.109039],[114.534539,26.108222],[114.535282,26.106695],[114.536207,26.101737],[114.537575,26.096732],[114.540541,26.095027],[114.541277,26.091734],[114.542696,26.090732],[114.544482,26.090608],[114.545225,26.089143],[114.545693,26.086983],[114.546775,26.086513],[114.551078,26.085472],[114.554287,26.085379],[114.555664,26.084577],[114.557206,26.084523],[114.560269,26.081793],[114.567133,26.081014],[114.569618,26.079386],[114.570944,26.074967],[114.568588,26.06993],[114.566405,26.068557],[114.564332,26.065926],[114.564073,26.06426],[114.564324,26.062378],[114.565382,26.061089],[114.566818,26.057579],[114.566999,26.05599],[114.566421,26.054424],[114.563837,26.052071],[114.562912,26.045575],[114.562,26.042466],[114.562244,26.040814],[114.56318,26.039348],[114.564486,26.038237],[114.567144,26.036895],[114.570492,26.036571],[114.575333,26.037427],[114.576356,26.036879],[114.577858,26.034202],[114.581056,26.030714],[114.587368,26.022488],[114.58891,26.017565],[114.589728,26.01748],[114.592588,26.015381],[114.595191,26.013104],[114.596985,26.012525],[114.600737,26.012109],[114.602566,26.012271],[114.608167,26.013799],[114.609657,26.014686],[114.612289,26.017565],[114.613524,26.020636],[114.615022,26.021477],[114.618342,26.022774],[114.62067,26.027288],[114.624292,26.027219],[114.626102,26.028191],[114.627584,26.031262],[114.629012,26.032335],[114.63385,26.029997],[114.637291,26.027805],[114.639199,26.027921],[114.644092,26.025714],[114.647081,26.023615],[114.650931,26.020065],[114.652489,26.019309],[114.659167,26.016924],[114.662282,26.015227],[114.662959,26.013644],[114.662892,26.011985],[114.661334,26.009029],[114.659262,26.006104],[114.657905,26.004862],[114.654384,26.002739],[114.65243,26.002708],[114.645523,26.003187],[114.644037,26.002099],[114.645098,25.99939],[114.643769,25.996356],[114.639749,25.991972],[114.636367,25.988545],[114.634302,25.987719],[114.633232,25.986013],[114.632788,25.98433],[114.632552,25.980347],[114.631274,25.978062],[114.628713,25.975005],[114.628284,25.973299],[114.628426,25.971075],[114.630876,25.969469],[114.631403,25.968049],[114.631632,25.964822],[114.630987,25.963609],[114.631596,25.962413],[114.637429,25.962513],[114.638703,25.961108],[114.639427,25.958267],[114.639478,25.955564],[114.638593,25.954421],[114.63702,25.953564],[114.633134,25.952368],[114.629067,25.949665],[114.627675,25.948445],[114.627388,25.946028],[114.628336,25.944468],[114.628658,25.94087],[114.629099,25.939526],[114.627978,25.937171],[114.626825,25.936924],[114.624792,25.938545],[114.62288,25.938136],[114.621523,25.935333],[114.622133,25.933912],[114.621158,25.932923],[114.618275,25.931139],[114.617225,25.929772],[114.614487,25.923339],[114.612654,25.923154],[114.611467,25.92035],[114.610727,25.919894],[114.608218,25.920597],[114.604981,25.92025],[114.603616,25.917747],[114.601032,25.918226],[114.598586,25.918033],[114.594708,25.91662],[114.591911,25.914696],[114.592017,25.913646],[114.594889,25.911514],[114.595243,25.91024],[114.594881,25.907907],[114.596135,25.907551],[114.599522,25.908509],[114.600702,25.907551],[114.600686,25.904693],[114.599809,25.902724],[114.596226,25.898838],[114.59304,25.898104],[114.590983,25.897015],[114.583742,25.893747],[114.580863,25.892573],[114.579392,25.891345],[114.578956,25.888409],[114.578114,25.886593],[114.576328,25.884685],[114.57634,25.88416],[114.581087,25.883256],[114.58244,25.882375],[114.582979,25.880359],[114.581842,25.879215],[114.579986,25.880536],[114.578409,25.880436],[114.578027,25.878999],[114.578185,25.871342],[114.577992,25.866227],[114.578606,25.864658],[114.579699,25.863769],[114.581252,25.86132],[114.583601,25.859852],[114.584206,25.858584],[114.584076,25.857077],[114.582126,25.854713],[114.582326,25.853144],[114.584867,25.850849],[114.585717,25.849658],[114.58681,25.849303],[114.589201,25.84979],[114.589681,25.851003],[114.589925,25.855439],[114.591136,25.856737],[114.593201,25.857371],[114.600592,25.857495],[114.606503,25.857139],[114.610385,25.85826],[114.611148,25.857742],[114.611175,25.85632],[114.609327,25.853283],[114.60937,25.851181],[114.612477,25.84319],[114.612839,25.841536],[114.613944,25.840655],[114.615569,25.838576],[114.615899,25.834379],[114.616827,25.83349],[114.61892,25.832849],[114.620788,25.830924],[114.620926,25.828296],[114.623278,25.824733],[114.623931,25.821362],[114.622062,25.819298],[114.620501,25.818448],[114.619781,25.816856],[114.619986,25.815132],[114.621602,25.81313],[114.623671,25.809628],[114.625571,25.805909],[114.627195,25.803752],[114.627309,25.802399],[114.624292,25.797165],[114.621846,25.794791],[114.619046,25.793237],[114.616076,25.792441],[114.613201,25.790585],[114.611242,25.788822],[114.610947,25.787021],[114.616041,25.783719],[114.61665,25.782226],[114.61571,25.77928],[114.615356,25.776496],[114.616399,25.774177],[114.620819,25.768995],[114.62279,25.766319],[114.623309,25.764904],[114.62292,25.763845],[114.618578,25.758655],[114.617185,25.757433],[114.616552,25.75584],[114.617335,25.754355],[114.617378,25.752174],[114.618644,25.75099],[114.621201,25.752089],[114.622448,25.752189],[114.624977,25.750279],[114.62561,25.747432],[114.625665,25.745027],[114.6243,25.742598],[114.622345,25.740757],[114.620292,25.739295],[114.617897,25.738506],[114.612017,25.737725],[114.61035,25.737926],[114.609752,25.738893],[114.609205,25.74136],[114.607616,25.741716],[114.604961,25.741593],[114.602609,25.741121],[114.599266,25.741121],[114.601166,25.738839],[114.602432,25.73559],[114.603065,25.730453],[114.604753,25.728171],[114.606236,25.724744],[114.608127,25.724172],[114.612772,25.72476],[114.616568,25.7238],[114.619946,25.721526],[114.62375,25.718106],[114.626279,25.713541],[114.626495,25.710493],[114.625016,25.706291],[114.622058,25.703622],[114.618904,25.701525],[114.615514,25.700179],[114.612147,25.699598],[114.607085,25.699405],[114.602232,25.699397],[114.596749,25.698631],[114.594008,25.699003],[114.591058,25.699769],[114.588942,25.699761],[114.587258,25.699188],[114.585359,25.699188],[114.581559,25.700527],[114.579247,25.700713],[114.57798,25.699947],[114.576301,25.698229],[114.574401,25.695172],[114.571038,25.689082],[114.565563,25.683556],[114.563872,25.681459],[114.557567,25.679548],[114.555455,25.677071],[114.553567,25.67269],[114.552096,25.670206],[114.547888,25.665252],[114.544738,25.662396],[114.543255,25.661823],[114.537162,25.660686],[114.534846,25.657063],[114.533166,25.656684],[114.528958,25.654779],[114.523707,25.650971],[114.521399,25.64525],[114.51614,25.636866],[114.512152,25.633537],[114.511314,25.631547],[114.510673,25.62886],[114.508156,25.624865],[114.506685,25.620862],[114.506268,25.616092],[114.506476,25.614954],[114.506071,25.609804],[114.508663,25.610099],[114.510724,25.608558],[114.511251,25.606908],[114.51286,25.608883],[114.515055,25.610648],[114.517599,25.611732],[114.522807,25.611732],[114.524313,25.610927],[114.525167,25.609363],[114.525521,25.606614],[114.528938,25.60213],[114.532997,25.598343],[114.536093,25.600566],[114.537823,25.600744],[114.541159,25.599667],[114.546602,25.600047],[114.5486,25.599396],[114.550039,25.598219],[114.551145,25.596353],[114.55118,25.594626],[114.550566,25.592209],[114.550452,25.589955],[114.551467,25.588987],[114.552781,25.58901],[114.553422,25.59413],[114.554212,25.596322],[114.55636,25.596507],[114.557788,25.595477],[114.558983,25.593386],[114.559093,25.588127],[114.559526,25.58678],[114.56104,25.585603],[114.565461,25.584092],[114.572175,25.583666],[114.575978,25.583798],[114.579195,25.584294],[114.582393,25.585928],[114.585646,25.58867],[114.58902,25.591156],[114.592603,25.592867],[114.596603,25.593448],[114.601036,25.593843],[114.60694,25.594037],[114.609681,25.593472],[114.611368,25.593665],[114.614951,25.595013],[114.617272,25.594626],[114.6217,25.594827],[114.629512,25.595609],[114.633736,25.594866],[114.640489,25.594308],[114.647034,25.59547],[114.649354,25.596051],[114.65147,25.597197],[114.655269,25.598722],[114.659498,25.597406],[114.663297,25.593611],[114.665617,25.590954],[114.666471,25.588104],[114.666766,25.586005],[114.669393,25.584177],[114.670428,25.582241],[114.671313,25.578949],[114.671053,25.575634],[114.669775,25.572907],[114.668288,25.57228],[114.664807,25.571769],[114.664009,25.57025],[114.66406,25.567841],[114.664953,25.5641],[114.667348,25.560985],[114.669574,25.557569],[114.669814,25.553362],[114.669747,25.548698],[114.667155,25.545188],[114.664736,25.541539],[114.664127,25.53837],[114.66419,25.535518],[114.665224,25.533279],[114.668434,25.530482],[114.675737,25.52367],[114.678738,25.51637],[114.6798,25.512201],[114.681495,25.50421],[114.682545,25.501172],[114.683183,25.496986],[114.682329,25.491475],[114.683816,25.489584],[114.688449,25.486747],[114.692984,25.484747],[114.693688,25.482956],[114.693723,25.481002],[114.695226,25.480576],[114.698042,25.48063],[114.701019,25.481282],[114.703843,25.481181],[114.70555,25.480692],[114.7066,25.479754],[114.706384,25.475576],[114.707234,25.472723],[114.713137,25.471211],[114.715764,25.471211],[114.717208,25.47201],[114.720067,25.476235],[114.722093,25.480072],[114.724571,25.482018],[114.727497,25.482444],[114.73259,25.479103],[114.73729,25.474622],[114.742329,25.468637],[114.746852,25.466668],[114.749786,25.463636],[114.753152,25.463443],[114.755048,25.464389],[114.757581,25.466296],[114.760307,25.468769],[114.76221,25.471234],[114.763902,25.475994],[114.764326,25.478274],[114.767693,25.481305],[114.77484,25.485685],[114.779473,25.487584],[114.78431,25.48777],[114.788507,25.486816],[114.792503,25.48815],[114.794808,25.488336],[114.800487,25.487188],[114.809722,25.48794],[114.813305,25.488685],[114.821498,25.491901],[114.824444,25.492661],[114.83159,25.493785],[114.83349,25.49439],[114.843087,25.494359],[114.848357,25.49563],[114.852282,25.498242],[114.854198,25.502172],[114.854968,25.505497],[114.856243,25.508217],[114.859507,25.510813],[114.8623,25.512208],[114.86359,25.513727],[114.863893,25.515231],[114.863539,25.517037],[114.861509,25.519114],[114.855975,25.523399],[114.853454,25.525623],[114.852585,25.526816],[114.855464,25.531443],[114.852821,25.533434],[114.850559,25.534689],[114.848105,25.536743],[114.847016,25.538331],[114.843739,25.541291],[114.843869,25.543321],[114.847452,25.546753],[114.848349,25.548148],[114.84724,25.55079],[114.847197,25.553269],[114.846229,25.55478],[114.843559,25.556174],[114.841561,25.556748],[114.838213,25.556368],[114.835696,25.558096],[114.835272,25.559428],[114.835071,25.565323],[114.834233,25.567035],[114.833816,25.569336],[114.834233,25.570854],[114.836554,25.573132],[114.838449,25.575409],[114.84033,25.577121],[114.843283,25.578074],[114.84455,25.578825],[114.846233,25.584541],[114.847913,25.587779],[114.847071,25.592349],[114.846438,25.59444],[114.846025,25.598815],[114.846866,25.603586],[114.848329,25.607202],[114.849179,25.607961],[114.854854,25.61023],[114.856121,25.61119],[114.858009,25.61404],[114.859472,25.617277],[114.859897,25.618802],[114.859897,25.621466],[114.859464,25.622612],[114.852742,25.62567],[114.850843,25.627583],[114.851267,25.630633],[114.853572,25.634442],[114.85631,25.637106],[114.860298,25.639955],[114.865973,25.643562],[114.867865,25.645281],[114.87122,25.649082],[114.880262,25.655166],[114.883896,25.656993],[114.881741,25.659524],[114.880844,25.659424],[114.879727,25.661421],[114.877631,25.662118],[114.87625,25.662048],[114.874917,25.663851],[114.875244,25.665245],[114.874485,25.665864],[114.87476,25.668913],[114.874252,25.670322],[114.872384,25.671042],[114.871928,25.674509],[114.870504,25.677203],[114.871208,25.678495],[114.870878,25.680027],[114.868947,25.681521],[114.8677,25.683363],[114.867381,25.686103],[114.865407,25.687635],[114.860935,25.688014],[114.858567,25.688788],[114.858378,25.689972],[114.857372,25.691465],[114.858115,25.692123],[114.855429,25.694058],[114.855409,25.695729],[114.854882,25.696604],[114.854123,25.696232],[114.851149,25.697571],[114.851232,25.698236],[114.847798,25.700047],[114.847739,25.701587],[114.847016,25.701726],[114.845812,25.700504],[114.844691,25.701231],[114.843397,25.700426],[114.842823,25.700937],[114.842803,25.703359],[114.841124,25.704233],[114.840762,25.702237],[114.837915,25.703297],[114.83664,25.702964],[114.83559,25.704388],[114.836412,25.705286],[114.837384,25.705053],[114.838666,25.706075],[114.839012,25.70869],[114.840562,25.709634],[114.840963,25.708543],[114.841395,25.709642],[114.841128,25.710965],[114.841513,25.712713],[114.840872,25.713294],[114.838992,25.711646],[114.837368,25.711615],[114.837596,25.713379],[114.836105,25.713278],[114.835378,25.714091],[114.837199,25.71536],[114.838449,25.717178],[114.838005,25.718276],[114.836652,25.719313],[114.835012,25.719553],[114.834745,25.720551],[114.833572,25.720814],[114.834658,25.721425],[114.833781,25.722972],[114.831311,25.7224],[114.83135,25.721603],[114.830107,25.721038],[114.830052,25.722818],[114.828715,25.723243],[114.827441,25.721642],[114.825604,25.720218],[114.824074,25.720311],[114.823028,25.721495],[114.822092,25.721123],[114.821801,25.722477],[114.820526,25.722647],[114.818985,25.725456],[114.820617,25.726887],[114.818292,25.727529],[114.815441,25.730059],[114.813345,25.729742],[114.812031,25.730724],[114.808534,25.731722],[114.808995,25.734553],[114.807854,25.736402],[114.805345,25.73955],[114.80536,25.741608],[114.806906,25.744694],[114.808766,25.746419],[114.805663,25.74891],[114.803429,25.749428],[114.802497,25.749088],[114.803134,25.753087],[114.803893,25.753133],[114.805408,25.755948],[114.804066,25.758733],[114.805105,25.758833],[114.805553,25.760689],[114.804991,25.763087],[114.806827,25.764386],[114.808326,25.764169],[114.807878,25.765716],[114.810989,25.76809],[114.811067,25.76932],[114.812975,25.769057],[114.812998,25.767858],[114.815142,25.7684],[114.820589,25.768694],[114.824098,25.76922],[114.827689,25.770178],[114.830461,25.771609],[114.832267,25.773396],[114.833722,25.775785],[114.834202,25.777332],[114.834619,25.781036],[114.834595,25.78344],[114.835307,25.785234],[114.839319,25.78859],[114.840762,25.789046],[114.844023,25.78934],[114.846288,25.790013],[114.849199,25.791784],[114.850748,25.793075],[114.851275,25.795],[114.853427,25.794915],[114.853254,25.793639],[114.854791,25.791768],[114.855633,25.793206],[114.857033,25.792317],[114.858992,25.795363],[114.859586,25.794381],[114.860349,25.794783],[114.859374,25.795549],[114.859991,25.796314],[114.860911,25.796028],[114.863153,25.793871],[114.864494,25.794088],[114.867299,25.793763],[114.866835,25.801672],[114.865785,25.803767],[114.863283,25.810238],[114.862866,25.812148],[114.862032,25.813856],[114.859519,25.817675],[114.856801,25.818827],[114.849875,25.818649],[114.845891,25.819036],[114.841698,25.820187],[114.841281,25.821324],[114.841706,25.823998],[114.838139,25.826101],[114.834568,25.827067],[114.833529,25.827824],[114.833541,25.831627],[114.831661,25.836017],[114.829344,25.837733],[114.82516,25.841551],[114.823276,25.844411],[114.823696,25.84727],[114.825388,25.849172],[114.825604,25.849929],[114.821828,25.852031],[114.815303,25.852997],[114.814049,25.854334],[114.813624,25.855485],[114.81364,25.858491],[114.812574,25.860825],[114.812869,25.862935],[114.812794,25.867146],[114.813891,25.870469],[114.816664,25.873358],[114.816735,25.875197],[114.817706,25.879686],[114.816172,25.882228],[114.816275,25.885234],[114.816857,25.886817],[114.818587,25.885751],[114.820054,25.885558],[114.821329,25.887273],[114.821344,25.891074],[114.820314,25.896984],[114.818859,25.900221],[114.816979,25.903272],[114.815299,25.90423],[114.813816,25.90328],[114.813175,25.901573],[114.812735,25.897757],[114.809777,25.89435],[114.808711,25.892248],[114.806599,25.890541],[114.8047,25.890734],[114.803236,25.891692],[114.802395,25.893029],[114.802611,25.894929],[114.804102,25.898166],[114.801797,25.901024],[114.800153,25.908455],[114.797632,25.910749],[114.793632,25.913607],[114.791111,25.915716],[114.787115,25.916287],[114.786057,25.916859],[114.784802,25.919145],[114.786509,25.924096],[114.789274,25.928089],[114.791606,25.930931],[114.797553,25.936808],[114.798395,25.938144],[114.799056,25.942692],[114.800121,25.944206],[114.800971,25.944592],[114.801396,25.946291],[114.799712,25.947627],[114.795736,25.951812],[114.795752,25.953703]]]]}}]}
            }
  },
  created(){
    // this.getlocation()
    // JS获取最近三十天的日期
        let lastPixelRatio = window.devicePixelRatio;
        window.addEventListener('resize', function () {
            let currentPixelRatio = window.devicePixelRatio;

            if (currentPixelRatio !== lastPixelRatio) {
                console.log('页面缩放变化了');
            }

            lastPixelRatio = currentPixelRatio;
        });
    let token=localStorage.getItem('token');
      if(token){
            // 获取当前时间
            const today = new Date();
            // 获取当前时间(today)的年份
            const year = today.getFullYear();
            // 获取月份
            const month = String(today.getMonth() + 1).padStart(2, '0');
            // 获取当前日
            const day = String(today.getDate()).padStart(2, '0');
            // 得到年月日
            const thisDayDate = `${year}-${month}-${day}`; //打印当前日期
            console.log(thisDayDate,'thisDayDate')
        this.getnum(thisDayDate)
      }else {



        this.getlocation()
      }


    var t = null;
    t = setTimeout(time,1000);//開始运行
    function time()
    {
       clearTimeout(t);//清除定时器
      var dt = new Date();
		var y=dt.getFullYear();
		var mt=dt.getMonth()+1;
		var day=dt.getDate();
       var h=dt.getHours();//获取时
       var m=dt.getMinutes();//获取分
       var s=dt.getSeconds();//获取秒
       document.getElementById("showTime").innerHTML = y+"年"+mt+"月"+day+"-"+h+"时"+m+"分"+s+"秒";
       t = setTimeout(time,1000); //设定定时器，循环运行     
    } 
        $(document).ready(function(){
    var html=$(".wrap ul").html()
    $(".wrap ul").append(html)
    var ls=$(".wrap li").length/2+1
    var i=0
     this.ref = setInterval(function(){
      i++
      if(i==ls){
        i=1
        $(".wrap ul").css({marginTop:0})
        $(".wrap ul").animate({marginTop:-'.52'*i+'rem'},1000)
      }
        $(".wrap ul").animate({marginTop:-'.52'*i+'rem'},1000)
    
    
    },2400);


    
    
    //     var html2=$(".adduser ul").html()
    // $(".adduser ul").append(html2)
    // var ls2=$(".adduser li").length/2+1
    // var a=0
    // this.ref2 = setInterval(function(){
    //   a++
    //   if(a==ls2){
    //     a=1
    //     $(".adduser ul").css({marginTop:0})
    //     $(".adduser ul").animate({marginTop:-'.5'*a+'rem'},800)
    //   }
    //     $(".adduser ul").animate({marginTop:-'.5'*a+'rem'},800)
    
    
    // },4300);
    
    $(window).on('load',function(){  
    $(".loading").fadeOut()
   })  
   
/****/
$(document).ready(function(){
var whei=$(window).width()
$("html").css({fontSize:whei/20})
$(window).resize(function(){
var whei=$(window).width()
$("html").css({fontSize:whei/20})
});
});
    
  
  
    
    
    
  })
    },

watch: {
    screenWidth (val) {
      // 为了避免频繁触发resize函数导致页面卡顿，使用定时器
      if (!this.timer) {
        // 一旦监听到的screenWidth值改变，就将其重新赋给data里的screenWidth
        this.screenWidth = val
        this.timer = true
        let that = this
        setTimeout(function () {
          that.echart_map()  // 操作
          that.echarts_1()  // 操作
          that.echarts_2()  // 操作
          that.echarts_5()  // 操作
          that.echarts_4()  // 操作
          that.echarts_31()  // 操作
          that.echarts_32()  // 操作
          that.echarts_33()  // 操作

          that.timer = false
        }, 400)
      }
    }
},

    mounted(){
        window.onresize = () => {
      return (() => {
        this.screenWidth = document.body.clientWidth
      })()
    }

        var that = this
		
		var timeoutId;
		var intervalId;
		
		intervalId = setInterval(function () {
			const today = new Date();
			// 获取当前时间(today)的年份
			const year = today.getFullYear();
			// 获取月份
			const month = String(today.getMonth() + 1).padStart(2, '0');
			// 获取当前日
			const day = String(today.getDate()).padStart(2, '0');
			// 得到年月日
			const thisDayDate = `${year}-${month}-${day}`; //打印当前日期
			console.log(thisDayDate,'thisDayDate')
                this.incount = 0
                this.tdrows  = '',
                this.data = [
            {
                name: '南水新区综合文化站',
                value:0,
            },{
                name: '东山街办综合文化站',
                value:0,
            },{
                name: '蓉江街办综合文化站',
                value:0,
            },
            {
                name: '龙岭镇综合文化站',
                value:0,
            },{
                name: '龙回镇综合文化站',
                value:0,
            },{
                name: '浮石乡综合文化站',
                value:0,
            },{
                name: '横寨乡综合文化站',
                value:0,
            },{
                name: '赤土畲族乡综合文化站',
                value:0,
            },{
                name: '朱坊乡综合文化站',
                value:0,
            },{
                name: '龙华镇综合文化站',
                value:0,
            },{
                name: '唐江镇综合文化站',
                value:0,
            },{
                name: '太窝乡综合文化站',
                value:0,
            },{
                name: '镜坝镇综合文化站',
                value:0,
            },{
                name: '麻双乡综合文化站',
                value:0,
            },{
                name: '横市镇综合文化站',
                value:0,
            },{
                name: '十八塘乡综合文化站',
                value:0,
            },{
                name: '大坪乡综合文化站',
                value:0,
            },{
                name: '坪市乡综合文化站',
                value:0,
            },{
                name: '隆木乡综合文化站',
                value:0,
            }
        ],
                this.innum1 = [0,0,0,0,0,0,0,0,0,]
              this.innum2= [0, 0, 0, 0, 0, 0, 0,0,0,0,],
              this.arrincount = [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,],
              this.outcount = 0

			that.getnum(thisDayDate)
			that.data30()
		    console.log(4);
		    // clearInterval(intervalId);	//清除定时器
		}, 120000);
		timeoutId = setTimeout(function () {
			console.log(1);
			console.log(intervalId)
		}, 120000);
		console.log(timeoutId)
        this.data30()
      this.echarts_31()
      this.echarts_32()
      this.echarts_33()
    this.echart_map();

    // echart_map中国地图







    },
    methods:{
        echart_map() {
        echarts.registerMap('南康', this.cZjson);
    // console.log(cZjson)
    // var chart = echarts.init(document.getElementById('main'));
    var myChart = echarts.init(document.getElementById('main'));
    function showProvince() {
        var geoCoordMap = {
            '南水新区综合文化站': [114.748464,25.643054],'东山街办综合文化站': [114.780125,25.691491,],'蓉江街办综合文化站': [114.752478,25.657534,],
            '龙岭镇综合文化站': [114.812207,25.720063,],'龙回镇综合文化站': [114.796791,25.521419,],'浮石乡综合文化站': [114.708836,25.579677,],
            '横寨乡综合文化站': [114.691985,25.646638,],'赤土畲族乡综合文化站': [114.652632,25.636658,],'朱坊乡综合文化站': [114.67265,25.723233,],
            '龙华镇综合文化站': [114.687676,25.823664,],'唐江镇综合文化站': [114.740118,25.787532,],'太窝乡综合文化站': [114.733184,25.745352,],
            '镜坝镇综合文化站': [114.742431,25.699905,],'麻双乡综合文化站': [114.698966,25.975298,],'横市镇综合文化站': [114.673811,26.042612,],
            '十八塘乡综合文化站': [114.702564,25.906626,],'大坪乡综合文化站': [114.671878,26.120926,],'坪市乡综合文化站': [114.559057,26.123515,],
            '隆木乡综合文化站': [114.560966,26.176262,]
        };
        var data = [
            {
                name: '南水新区综合文化站',
                value:[0,'南水新区综合文化站'],
                //value: [50,'电商进农村示范县：<br/>项目承建企业24家<br/>电商服务站目前数量24个站点<br/>广西金岸科技有限公司等企业均以优秀标准验收<br/>主要推广特产富川脐橙...']
            },{
                name: '东山街办综合文化站',
                value:[0,'东山街办综合文化站'],
                //value: [50,'电商进农村示范县：<br/>项目承建企业24家<br/>电商服务站目前数量24个站点<br/>广西金岸科技有限公司等企业均以优秀标准验收<br/>主要推广特产富川脐橙...']
            },{
                name: '蓉江街办综合文化站',
                value:[0,'蓉江街办综合文化站'],
                //value: [50,'电商进农村示范县：<br/>项目承建企业24家<br/>电商服务站目前数量24个站点<br/>广西金岸科技有限公司等企业均以优秀标准验收<br/>主要推广特产富川脐橙...']
            },
            {
                name: '龙岭镇综合文化站',
                value:[0,'龙岭镇综合文化站'],

                //value: [50,'电商进农村示范县：<br/>项目承建企业24家<br/>电商服务站目前数量24个站点<br/>广西金岸科技有限公司等企业均以优秀标准验收<br/>主要推广特产富川脐橙...']
            },{
                name: '龙回镇综合文化站',
                value:[0,'龙回镇综合文化站'],
                //value: [50,'电商进农村示范县：<br/>项目承建企业24家<br/>电商服务站目前数量24个站点<br/>广西金岸科技有限公司等企业均以优秀标准验收<br/>主要推广特产富川脐橙...']
            },{
                name: '浮石乡综合文化站',
                value:[0,'浮石乡综合文化站'],
                //value: [50,'电商进农村示范县：<br/>项目承建企业24家<br/>电商服务站目前数量24个站点<br/>广西金岸科技有限公司等企业均以优秀标准验收<br/>主要推广特产富川脐橙...']
            },{
                name: '横寨乡综合文化站',
                value:[0,'横寨乡综合文化站'],
                //value: [50,'电商进农村示范县：<br/>项目承建企业24家<br/>电商服务站目前数量24个站点<br/>广西金岸科技有限公司等企业均以优秀标准验收<br/>主要推广特产富川脐橙...']
            },{
                name: '赤土畲族乡综合文化站',
                value:[0,'赤土畲族乡综合文化站'],
                // value: [50,'电商进农村示范县：<br/>项目承建企业2家<br/>电商服务站目前数量94个站点<br/>广西乐村淘科技有限公司、广西国际电子商务中心<br/>主要推广的产品有西林沙糖桔、麻鸭、姜晶等地理标志保护产品']
            },{
                name: '朱坊乡综合文化站',
                value:[0,'朱坊乡综合文化站'],
                //value: [50,'电商进农村示范县：<br/>项目承建企业24家<br/>电商服务站目前数量24个站点<br/>广西金岸科技有限公司等企业均以优秀标准验收<br/>主要推广特产富川脐橙...']
            },{
                name: '龙华镇综合文化站',
                value:[0,'龙华镇综合文化站'],
                //value: [50,'电商进农村示范县：<br/>项目承建企业24家<br/>电商服务站目前数量24个站点<br/>广西金岸科技有限公司等企业均以优秀标准验收<br/>主要推广特产富川脐橙...']
            },{
                name: '唐江镇综合文化站',
                value:[0,'唐江镇综合文化站'],
                //value: [50,'电商进农村示范县：<br/>项目承建企业24家<br/>电商服务站目前数量24个站点<br/>广西金岸科技有限公司等企业均以优秀标准验收<br/>主要推广特产富川脐橙...']
            },{
                name: '太窝乡综合文化站',
                value:[0,'太窝乡综合文化站'],
                //value: [50,'电商进农村示范县：<br/>项目承建企业24家<br/>电商服务站目前数量24个站点<br/>广西金岸科技有限公司等企业均以优秀标准验收<br/>主要推广特产富川脐橙...']
            },{
                name: '镜坝镇综合文化站',
                value:[0,'镜坝镇综合文化站'],
                //value: [50,'电商进农村示范县：<br/>项目承建企业24家<br/>电商服务站目前数量24个站点<br/>广西金岸科技有限公司等企业均以优秀标准验收<br/>主要推广特产富川脐橙...']
            },{
                name: '麻双乡综合文化站',
                value:[0,'麻双乡综合文化站'],
                // value: [50,'项目承建企业1家<br/>电商服务站目前数量85个站点<br/>参加电商培训人数1500人<br/>特色粮经作物：包括蚕桑、火麻、龙骨花、中药材、红薯、马铃薯、小杂粮等。<br/>主要承建内容:县级服务中心建设、乡镇级服务站、村级服务点建设']
                
            },{
                name: '横市镇综合文化站',
                value:[0,'横市镇综合文化站'],
                // value: [50,'项目承建企业24家<br/>电商服务站目前数量24个站点<br/>广西金岸科技有限公司等企业均以优秀标准验收<br/>主要推广特产富川脐橙...']
            },{
                name: '十八塘乡综合文化站',
                value:[0,'十八塘乡综合文化站'],
                // value: [50,'项目承建企业1家<br/>电商服务站目前数量60个站点<br/>参加电商培训人数1500人<br/>特色产品：靖西绣球、靖西壮锦、靖西东利大香儒<br/>主要承建内容:靖西各镇乡村服务站点建设']
            },{
                name: '大坪乡综合文化站',
                value:[0,'大坪乡综合文化站'],
                //value: [50,'电商进农村示范县：<br/>项目承建企业24家<br/>电商服务站目前数量24个站点<br/>广西金岸科技有限公司等企业均以优秀标准验收<br/>主要推广特产富川脐橙...']
            },{
                name: '坪市乡综合文化站',
                value:[0,'坪市乡综合文化站'],
                //value: [50,'电商进农村示范县：<br/>项目承建企业24家<br/>电商服务站目前数量24个站点<br/>广西金岸科技有限公司等企业均以优秀标准验收<br/>主要推广特产富川脐橙...']
            },{
                name: '隆木乡综合文化站',
                value:[0,'隆木乡综合文化站'],
                //value: [50,'电商进农村示范县：<br/>项目承建企业24家<br/>电商服务站目前数量24个站点<br/>广西金岸科技有限公司等企业均以优秀标准验收<br/>主要推广特产富川脐橙...']
            }
        ];
        var max = 480,
            min = 9;
        var maxSize4Pin = 50,
            minSize4Pin = 20;
        var convertData = function (data) {
            var res = [];
            for (var i = 0; i < data.length; i++) {
                var geoCoord = geoCoordMap[data[i].name];
                
                if (geoCoord) {
                    res.push({
                        name: data[i].name,
                        value: geoCoord.concat(data[i].value),                            
                    });
                }
            }
            return res;
        };

        var option = {
            tooltip: {
                trigger: 'item',
                formatter: function loadData(result){
                    return result.name+'<br />' +result.value[3];
                }
            },
            geo: {
                zoom:1.2, 
                show: true,
                map:'南康',
                mapType: '南康',
                label: {
                    normal: {
                        show : true,
                        textStyle:{color:"#4bf316"}
                    },
                    emphasis: {
                        show: true,
                        textStyle: {
                            color: '#fff'
                        }
                    }, 
                },
                roam: true,
                itemStyle: {                        
                    normal: {
                        borderColor: 'rgba(147, 235, 248, 1)',
                        borderWidth: 2,
                        areaColor: {
                            type: 'radial',
                            x: 0.5,
                            y: 0.5,
                            r: 0.8,
                            colorStops: [{
                                offset: 0,
                                color: 'rgba(175,238,238, 0)' // 0% 处的颜色
                            }, {
                                offset: 1,
                                color: 'rgba(   47,79,79, .2)' // 100% 处的颜色
                            }],
                            globalCoord: false // 缺省为 false
                        },
                        shadowColor: 'rgba(128, 217, 248, 1)',
                        shadowOffsetX: -2,
                        shadowOffsetY: 2,
                        shadowBlur: 10
                    },
                    emphasis: {
                        areaColor: '#389BB7',
                        borderWidth: 0
                    }
                }
            },
            series: [                    
                {
                    name: '电商进农村示范县',
                    type: 'scatter',
                    coordinateSystem: 'geo',
                    symbol: 'pin',
                    symbolSize: function(val) {
                        var a = (maxSize4Pin - minSize4Pin) / (max - min);
                        var b = minSize4Pin - a * min;
                        b = maxSize4Pin - a * max;
                        return a * val[2] + b;
                    },
                    label: {
                        normal: {
                            formatter: '{b}',
                            show: true,
                            textStyle: {
                                color: '#fff',
                                fontSize: 10,
                            }
                        }
                    },
                    itemStyle: {
                        normal: {
                            color: 'red', //标志颜色
                        }
                    },
                    zlevel: 6,
                    data: convertData(data),
                },
                {
                    type: 'effectScatter',
                    coordinateSystem: 'geo',
                    data: convertData(data.sort(function (a, b) {
                        return b.value - a.value;
                    }).slice(0, 47)),
                    symbolSize: function (val) {
                        return val[2] / 10;
                    },
                    showEffectOn: 'render',
                    rippleEffect: {
                        brushType: 'stroke'
                    },
                    hoverAnimation: true,
                    itemStyle: {
                        normal: {
                            color: '#05C3F9',
                            shadowBlur: 10,
                            shadowColor: '#05C3F9'
                        }
                    },
                    zlevel: 1
                },

            ]
        }
        myChart.setOption(option
            );
    }
    showProvince();
    window.addEventListener("resize", function () {
        myChart.resize();
    });
    },
        async getlocation(){
            await this.axios.post('/api/oauth/token?client_id=45ccab1007b3455c9982b65e780a3034&client_secret=c44b8d8507de419b99e401449db6574a&grant_type=client_credentials&scope=app').then(re => {
                localStorage.setItem('token',re.access_token);
			const today = new Date();
				// 获取当前时间(today)的年份
				const year = today.getFullYear();
				// 获取月份
				const month = String(today.getMonth() + 1).padStart(2, '0');
				// 获取当前日
				const day = String(today.getDate()).padStart(2, '0');
				// 得到年月日
				const thisDayDate = `${year}-${month}-${day}`; //打印当前日期
                this.incount = 0
                this.tdrows  = '',
                this.data = [
            {
                name: '南水新区综合文化站',
                value:0,
            },{
                name: '东山街办综合文化站',
                value:0,
            },{
                name: '蓉江街办综合文化站',
                value:0,
            },
            {
                name: '龙岭镇综合文化站',
                value:0,
            },{
                name: '龙回镇综合文化站',
                value:0,
            },{
                name: '浮石乡综合文化站',
                value:0,
            },{
                name: '横寨乡综合文化站',
                value:0,
            },{
                name: '赤土畲族乡综合文化站',
                value:0,
            },{
                name: '朱坊乡综合文化站',
                value:0,
            },{
                name: '龙华镇综合文化站',
                value:0,
            },{
                name: '唐江镇综合文化站',
                value:0,
            },{
                name: '太窝乡综合文化站',
                value:0,
            },{
                name: '镜坝镇综合文化站',
                value:0,
            },{
                name: '麻双乡综合文化站',
                value:0,
            },{
                name: '横市镇综合文化站',
                value:0,
            },{
                name: '十八塘乡综合文化站',
                value:0,
            },{
                name: '大坪乡综合文化站',
                value:0,
            },{
                name: '坪市乡综合文化站',
                value:0,
            },{
                name: '隆木乡综合文化站',
                value:0,
            }
        ],
                this.innum1 = [0,0,0,0,0,0,0,0,0,]
              this.innum2= [0, 0, 0, 0, 0, 0, 0,0,0,0,],
              this.arrincount = [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,],
              this.outcount = 0
				this.getnum(thisDayDate)
				this.data30()
        })
        },
        async getnum( time){
            await this.axios.get(`/api/v1/customization/passengerFlow/details?pageNo=1&pageSize=999&dateTime=${time}`).then(re => {
                this.contum(re.rows)
                this.indata(re.rows)
                this.incount = this.incountdata(re.rows)
                // this.outcount = this.outcountdata(re.rows)
                this.tdrows = re.rows
                // console.log(re,'num')

        }).catch(error => {
				if(error.response.status == 401){
					this.getlocation()
				}
		});
        },
        async getnum2( index,time){
            await this.axios.get(`/api/v1/customization/passengerFlow/details?pageNo=1&pageSize=999&dateTime=${time}`).then(re => {
                console.log(this.incountdata(re.rows),'this.incountdata(re.rows)')
                this.arrincount[index] = this.incountdata(re.rows)
                re.rows.forEach(e => {
                    this.outcount = this.outcount + e.passengerInCount
                if(e.storeName == '南水新区综合文化站'){
                    this.data[0].value = e.passengerInCount + this.data[0].value
                }else if( e.storeName == '东山街办综合文化站' ){
                    this.data[1].value = e.passengerInCount + this.data[1].value
                }else if( e.storeName == '蓉江街办综合文化站' ){
                    this.data[2].value = e.passengerInCount + this.data[2].value
                }else if( e.storeName == '龙岭镇综合文化站' ){
                    this.data[3].value = e.passengerInCount + this.data[3].value
                }else if( e.storeName == '龙回镇综合文化站' ){
                    this.data[4].value = e.passengerInCount + this.data[4].value
                }else if( e.storeName == '浮石乡综合文化站' ){
                    this.data[5].value = e.passengerInCount + this.data[5].value
                }else if( e.storeName == '横寨乡综合文化站' ){
                    this.data[6].value = e.passengerInCount + this.data[6].value
                }else if( e.storeName == '赤土畲族乡综合文化站' ){
                    this.data[7].value = e.passengerInCount + this.data[7].value
                }else if( e.storeName == '朱坊乡综合文化站' ){
                    this.data[8].value = e.passengerInCount + this.data[8].value
                }else if( e.storeName == '龙华镇综合文化站' ){
                    this.data[9].value = e.passengerInCount + this.data[9].value
                }else if( e.storeName == '唐江镇综合文化站' ){
                    this.data[10].value = e.passengerInCount + this.data[10].value
                }else if( e.storeName == '太窝乡综合文化站' ){
                    this.data[11].value = e.passengerInCount + this.data[11].value
                }else if( e.storeName == '镜坝镇综合文化站' ){
                    this.data[12].value = e.passengerInCount + this.data[12].value
                }else if( e.storeName == '麻双乡综合文化站' ){
                    this.data[13].value = e.passengerInCount + this.data[13].value
                }else if( e.storeName == '横市镇综合文化站' ){
                    this.data[14].value = e.passengerInCount + this.data[14].value
                }else if( e.storeName == '十八塘乡综合文化站' ){
                    this.data[15].value = e.passengerInCount + this.data[15].value
                }else if( e.storeName == '大坪乡综合文化站' ){
                    this.data[16].value = e.passengerInCount + this.data[16].value
                }else if( e.storeName == '坪市乡综合文化站' ){
                    this.data[17].value = e.passengerInCount + this.data[17].value
                }else if( e.storeName == '隆木乡综合文化站' ){
                    this.data[18].value = e.passengerInCount + this.data[18].value
                }
            })

                if (index == 29) {
                            this.echarts_4()
                }
        })
        },
        contum(re){
                this.timenum = [0, 0, 0, 0, 0, 0, 0,0,0,0,0,0,0,]

            re.forEach(e => {
                // console.log(e.dateTime.split(' '),'s')
                var time  = e.dateTime.split(' ')[1]
                if( time == '00:00:00' || time == '01:00:00'){
                    this.timenum[0] = e.passengerInCount + this.timenum[0]
                    // console.log(this.timenum[0])
                }else if( time == '02:00:00' || time == '03:00:00'){
                    this.timenum[1] = e.passengerInCount + this.timenum[1]
                    // console.log(this.timenum[1])
                }else if( time == '04:00:00' || time == '05:00:00'){
                    this.timenum[2] = e.passengerInCount + this.timenum[2]
                    // console.log( this.timenum[2])
                }else if( time == '06:00:00' || time == '07:00:00'){
                    this.timenum[3] = e.passengerInCount + this.timenum[3]
                    // console.log(this.timenum[3])
                }else if( time == '08:00:00' || time == '09:00:00'){
                    this.timenum[4] = e.passengerInCount + this.timenum[4]
                    // console.log(this.timenum[4])
                }else if( time == '10:00:00' || time == '11:00:00'){
                    this.timenum[5] = e.passengerInCount + this.timenum[5]
                    // console.log(this.timenum[5])
                }else if( time == '12:00:00' || time == '13:00:00'){
                    this.timenum[6] = e.passengerInCount + this.timenum[6]
                    // console.log(this.timenum[6])
                }else if( time == '14:00:00' || time == '15:00:00'){
                    this.timenum[7] = e.passengerInCount + this.timenum[7]
                    // console.log(this.timenum[7])
                }else if( time == '16:00:00' || time == '17:00:00'){
                    this.timenum[8] = e.passengerInCount + this.timenum[8]
                    // console.log(this.timenum[8])
                }else if( time == '18:00:00' || time == '19:00:00'){
                    this.timenum[9] = e.passengerInCount + this.timenum[9]
                    // console.log(this.timenum[9])
                }else if( time == '20:00:00' || time == '21:00:00'){
                    this.timenum[10] = e.passengerInCount + this.timenum[10]
                    // console.log(this.timenum[10])
                }else if( time == '22:00:00' || time == '23:00:00'){
                    this.timenum[11] = e.passengerInCount + this.timenum[11]
                    // console.log(this.timenum[11])
                }
            });

            this.echarts_1()
            
        },
        indata(re){
                this.innum1 = [0,0,0,0,0,0,0,0,0,]
              this.innum2= [0, 0, 0, 0, 0, 0, 0,0,0,0,],
            re.forEach(e => {
                if(e.storeName == '南水新区综合文化站'){
                    this.innum1[0] = e.passengerInCount + this.innum1[0]
                }else if( e.storeName == '东山街办综合文化站' ){
                    this.innum1[1] = e.passengerInCount + this.innum1[1]
                }else if( e.storeName == '蓉江街办综合文化站' ){
                    this.innum1[2] = e.passengerInCount + this.innum1[2]
                }else if( e.storeName == '龙岭镇综合文化站' ){
                    this.innum1[3] = e.passengerInCount + this.innum1[3]
                }else if( e.storeName == '龙回镇综合文化站' ){
                    this.innum1[4] = e.passengerInCount + this.innum1[4]
                }else if( e.storeName == '浮石乡综合文化站' ){
                    this.innum1[5] = e.passengerInCount + this.innum1[5]
                }else if( e.storeName == '横寨乡综合文化站' ){
                    this.innum1[6] = e.passengerInCount + this.innum1[6]
                }else if( e.storeName == '赤土畲族乡综合文化站' ){
                    this.innum1[7] = e.passengerInCount + this.innum1[7]
                }else if( e.storeName == '朱坊乡综合文化站' ){
                    this.innum1[8] = e.passengerInCount + this.innum1[8]
                }else if( e.storeName == '龙华镇综合文化站' ){
                    this.innum2[0] = e.passengerInCount + this.innum2[0]
                }else if( e.storeName == '唐江镇综合文化站' ){
                    this.innum2[1] = e.passengerInCount + this.innum2[1]
                }else if( e.storeName == '太窝乡综合文化站' ){
                    this.innum2[2] = e.passengerInCount + this.innum2[2]
                }else if( e.storeName == '镜坝镇综合文化站' ){
                    this.innum2[3] = e.passengerInCount + this.innum2[3]
                }else if( e.storeName == '麻双乡综合文化站' ){
                    this.innum2[4] = e.passengerInCount + this.innum2[4]
                }else if( e.storeName == '横市镇综合文化站' ){
                    this.innum2[5] = e.passengerInCount + this.innum2[5]
                }else if( e.storeName == '十八塘乡综合文化站' ){
                    this.innum2[6] = e.passengerInCount + this.innum2[6]
                }else if( e.storeName == '大坪乡综合文化站' ){
                    this.innum2[7] = e.passengerInCount + this.innum2[7]
                }else if( e.storeName == '坪市乡综合文化站' ){
                    this.innum2[8] = e.passengerInCount + this.innum2[8]
                }else if( e.storeName == '隆木乡综合文化站' ){
                    this.innum2[9] = e.passengerInCount + this.innum2[9]
                }
            })
      this.echarts_2()
      this.echarts_5()


        },
        data30(){
        var myDate = new Date();
        myDate.setDate(myDate.getDate() - 29);
        var dateTemp;
        var flag = 1;
        var day;
         this.time = []
                         this.data = [
            {
                name: '南水新区综合文化站',
                value:0,
            },{
                name: '东山街办综合文化站',
                value:0,
            },{
                name: '蓉江街办综合文化站',
                value:0,
            },
            {
                name: '龙岭镇综合文化站',
                value:0,
            },{
                name: '龙回镇综合文化站',
                value:0,
            },{
                name: '浮石乡综合文化站',
                value:0,
            },{
                name: '横寨乡综合文化站',
                value:0,
            },{
                name: '赤土畲族乡综合文化站',
                value:0,
            },{
                name: '朱坊乡综合文化站',
                value:0,
            },{
                name: '龙华镇综合文化站',
                value:0,
            },{
                name: '唐江镇综合文化站',
                value:0,
            },{
                name: '太窝乡综合文化站',
                value:0,
            },{
                name: '镜坝镇综合文化站',
                value:0,
            },{
                name: '麻双乡综合文化站',
                value:0,
            },{
                name: '横市镇综合文化站',
                value:0,
            },{
                name: '十八塘乡综合文化站',
                value:0,
            },{
                name: '大坪乡综合文化站',
                value:0,
            },{
                name: '坪市乡综合文化站',
                value:0,
            },{
                name: '隆木乡综合文化站',
                value:0,
            }
        ],
         this.outcount = 0
        for (var i = 0; i < 30; i++) {
          if(myDate.getDate()<10){
            day='0'+myDate.getDate().toString()
          }else {
            day=myDate.getDate().toString()
          }
          var month =myDate.getMonth()+1;
           dateTemp = myDate.getFullYear()+"-"+(month < 10 ? '0' + month : '' + month)+"-"+day;
           this.time.push(dateTemp);
          myDate.setDate(myDate.getDate() + flag);
          }

          this.time.forEach( (e,index) => {
             this.getnum2(index,e)
            
            })

        },

        incountdata(re){
            var couont = 0 
             re.forEach(e => {
                couont =  e.passengerInCount + couont
             })
             return couont
        },
        outcountdata(re){
            var couont = 0 
             re.forEach(e => {
                couont =  e.passengerOutCount + couont
             })
             return couont
        },

        echarts_1() {
            // 基于准备好的dom，初始化echarts实例
            var myChart = echarts.init(document.getElementById('echart1'));
    
          var  option = {
      //  backgroundColor: '#00265f',
        tooltip: {
            trigger: 'axis',
            axisPointer: {
                type: 'shadow'
            }
        },
        grid: {
            left: '0%',
            top:'10px',
            right: '0%',
            bottom: '4%',
           containLabel: true
        },
        xAxis: [{
            type: 'category',
                  data: ['00:00', '02:00',  '04:00',  '06:00','08:00','10:00','12:00','14:00','16:00','18:00','20:00','22:00',],
            axisLine: {
                show: true,
             lineStyle: {
                    color: "rgba(255,255,255,.1)",
                    width: 1,
                    type: "solid"
                },
            },
            
            axisTick: {
                show: false,
            },
            axisLabel:  {
                    interval: 0,
                   // rotate:50,
                    show: true,
                    splitNumber: 15,
                    textStyle: {
                         color: "rgba(255,255,255,.6)",
                        fontSize: '12',
                    },
                },
        }],
        yAxis: [{
            type: 'value',
            axisLabel: {
               //formatter: '{value} %'
                show:true,
                 textStyle: {
                         color: "rgba(255,255,255,.6)",
                        fontSize: '12',
                    },
            },
            axisTick: {
                show: false,
            },
            axisLine: {
                show: true,
                lineStyle: {
                    color: "rgba(255,255,255,.1	)",
                    width: 1,
                    type: "solid"
                },
            },
            splitLine: {
                lineStyle: {
                   color: "rgba(255,255,255,.1)",
                }
            }
        }],
        series: [
            {
            type: 'bar',
            data: this.timenum,
            barWidth:'35%', //柱子宽度
           // barGap: 1, //柱子之间间距
            itemStyle: {
                normal: {
                    color:'#2f89cf',
                    opacity: 1,
                    barBorderRadius: 5,
                    label: {
                    formatter: "{c}"+"人",
                    show: true,
                    position: "top",
                    textStyle: {
                        fontWeight: "bolder",
                        fontSize: "12",
                        color: "#fff"
                    }
                    },
                }
            }
        }
            
        ]
    };
          
            // 使用刚指定的配置项和数据显示图表。
            myChart.setOption(option);
            window.addEventListener("resize",function(){
                myChart.resize();
            });
        },
         echarts_2() {
            // 基于准备好的dom，初始化echarts实例
            var myChart = echarts.init(document.getElementById('echart2'));
    
          var option = {
      //  backgroundColor: '#00265f',
        tooltip: {
            trigger: 'axis',
            axisPointer: { type: 'shadow'}
        },
        grid: {
            left: '0%',
            top:'10px',
            right: '0%',
            bottom: '4%',
           containLabel: true
        },
        xAxis: [{
            type: 'category',
                  data: ['南水', '东山', '蓉江', '龙岭', '龙回', '浮石', '横寨','赤土','朱坊'],
            axisLine: {
                show: true,
             lineStyle: {
                    color: "rgba(255,255,255,.1)",
                    width: 1,
                    type: "solid"
                },
            },
            
            axisTick: {
                show: false,
            },
            axisLabel:  {
                    interval: 0,
                   // rotate:50,
                    show: true,
                    splitNumber: 15,
                    textStyle: {
                         color: "rgba(255,255,255,.6)",
                        fontSize: '12',
                    },
                },
        }],
        yAxis: [{
            type: 'value',
            axisLabel: {
               //formatter: '{value} %'
                show:true,
                 textStyle: {
                         color: "rgba(255,255,255,.6)",
                        fontSize: '12',
                    },
            },
            axisTick: {
                show: false,
            },
            axisLine: {
                show: true,
                lineStyle: {
                    color: "rgba(255,255,255,.1	)",
                    width: 1,
                    type: "solid"
                },
            },
            splitLine: {
                lineStyle: {
                   color: "rgba(255,255,255,.1)",
                }
            }
        }],
        series: [
            {
           
            type: 'bar',
            data: this.innum1,
            barWidth:'35%', //柱子宽度
           // barGap: 1, //柱子之间间距
            itemStyle: {
                normal: {
                    color:'#27d08a',
                    opacity: 1,
                    barBorderRadius: 5,

                label: {
                  formatter: "{c}"+"人",
                  show: true,
                  position: "top",
                  textStyle: {
                    fontWeight: "bolder",
                    fontSize: "12",
                    color: "#fff"
                  }
                },

                }
            }
        }
            
        ]
    };
          
            // 使用刚指定的配置项和数据显示图表。
            myChart.setOption(option);
            window.addEventListener("resize",function(){
                myChart.resize();
            });
        },
         echarts_4() {
            // 基于准备好的dom，初始化echarts实例
            var myChart = echarts.init(document.getElementById('echart4'));
    
        var option = {
            tooltip: {
            trigger: 'axis',
            axisPointer: {
                lineStyle: {
                    color: '#dddc6b'
                }
            }
        },
                legend: {
        top:'0%',
            data:['',''],
                    textStyle: {
               color: 'rgba(255,255,255,.5)',
                fontSize:'12',
            }
        },
        grid: {
            left: '10',
            top: '30',
            right: '10',
            bottom: '10',
            containLabel: true
        },
    
        xAxis: [{
            type: 'category',
            boundaryGap: false,
    axisLabel:  {
                    textStyle: {
                         color: "rgba(255,255,255,.6)",
                        fontSize:12,
                    },
                },
            axisLine: {
                lineStyle: { 
                    color: 'rgba(255,255,255,.2)'
                }
    
            },
    
       data: this.time
    
        }, {
    
            axisPointer: {show: false},
            axisLine: {  show: false},
            position: 'bottom',
            offset: 20,
    
           
    
        }],
    
        yAxis: [{
            type: 'value',
            axisTick: {show: false},
            axisLine: {
                lineStyle: {
                    color: 'rgba(255,255,255,.1)'
                }
            },
           axisLabel:  {
                    textStyle: {
                         color: "rgba(255,255,255,.6)",
                        fontSize:12,
                    },
                },
    
            splitLine: {
                lineStyle: {
                     color: 'rgba(255,255,255,.1)'
                }
            }
        }],
        series: [
            {
            name: '',
            type: 'line',
             smooth: true,
            symbol: 'circle',
            symbolSize: 5,
            showSymbol: false,
            lineStyle: {
                
                normal: {
                    color: '#0184d5',
                    width: 2
                }
            },
            areaStyle: {
                normal: {
                    color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                        offset: 0,
                        color: 'rgba(1, 132, 213, 0.4)'
                    }, {
                        offset: 0.8,
                        color: 'rgba(1, 132, 213, 0.1)'
                    }], false),
                    shadowColor: 'rgba(0, 0, 0, 0.1)',
                }
            },
                itemStyle: {
                normal: {
                    color: '#0184d5',
                    borderColor: 'rgba(221, 220, 107, .1)',
                    borderWidth: 12
                }
            },
            data: this.arrincount
    
        }, 
    {
            name: '',
            type: 'line',
            smooth: true,
            symbol: 'circle',
            symbolSize: 5,
            showSymbol: false,
            lineStyle: {
                
                normal: {
                    color: '#00d887',
                    width: 2
                }
            },
            areaStyle: {
                normal: {
                    color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                        offset: 0,
                        color: 'rgba(0, 216, 135, 0.4)'
                    }, {
                        offset: 0.8,
                        color: 'rgba(0, 216, 135, 0.1)'
                    }], false),
                    shadowColor: 'rgba(0, 0, 0, 0.1)',
                }
            },
                itemStyle: {
                normal: {
                    color: '#00d887',
                    borderColor: 'rgba(221, 220, 107, .1)',
                    borderWidth: 12
                }
            },
            data: this.arrincount
    
        }, 
        
             ]
    
    };
          
            // 使用刚指定的配置项和数据显示图表。
            myChart.setOption(option);
            window.addEventListener("resize",function(){
                myChart.resize();
            });
            // window.addEventListener('resize',function () {//执行
            //     myChart.resize();
            // })
        },
         echarts_5() {
            // 基于准备好的dom，初始化echarts实例
            var myChart = echarts.init(document.getElementById('echart5'));
    
          var option = {
      //  backgroundColor: '#00265f',
        tooltip: {
            trigger: 'axis',
            axisPointer: {
                type: 'shadow'
            }
        },
        
        grid: {
            left: '0%',
            top:'10px',
            right: '0%',
            bottom: '2%',
           containLabel: true
        },
        xAxis: [{
            type: 'category',
                  data: ['龙华', '唐江', '太窝', '镜坝', '麻双', '横市', '十八塘', '大坪','坪市','隆木'],
            axisLine: {
                show: true,
             lineStyle: {
                    color: "rgba(255,255,255,.1)",
                    width: 1,
                    type: "solid"
                },
            },
            
            axisTick: {
                show: false,
            },
            axisLabel:  {
                    interval: 0,
                   // rotate:50,
                    show: true,
                    splitNumber: 15,
                    textStyle: {
                         color: "rgba(255,255,255,.6)",
                        fontSize: '12',
                    },
                },
        }],
        yAxis: [{
            type: 'value',
            axisLabel: {
               //formatter: '{value} %'
                show:true,
                 textStyle: {
                         color: "rgba(255,255,255,.6)",
                        fontSize: '12',
                    },
            },
            axisTick: {
                show: false,
            },
            axisLine: {
                show: true,
                lineStyle: {
                    color: "rgba(255,255,255,.1	)",
                    width: 1,
                    type: "solid"
                },
            },
            splitLine: {
                lineStyle: {
                   color: "rgba(255,255,255,.1)",
                }
            }
        }],
        series: [{
            type: 'bar',
            data: this.innum2,
            barWidth:'35%', //柱子宽度
           // barGap: 1, //柱子之间间距
            itemStyle: {
                normal: {
                    color:'#2f89cf',
                    opacity: 1,
                    barBorderRadius: 5,
                    label: {
                    formatter: "{c}"+"人",
                    show: true,
                    position: "top",
                    textStyle: {
                        fontWeight: "bolder",
                        fontSize: "12",
                        color: "#fff"
                    }
                    },
                }
            }
        }
        ]
    };
          
            // 使用刚指定的配置项和数据显示图表。
            myChart.setOption(option);
            window.addEventListener("resize",function(){
                myChart.resize();
            });
        },
         echarts_31() {
            // 基于准备好的dom，初始化echarts实例
            var myChart = echarts.init(document.getElementById('fb1')); 
            var option = {
       
            title: [{
            text: '年龄分布',
            left: 'center',
            textStyle: {
                color: '#fff',
                fontSize:'16'
            }
    
        }],
        tooltip: {
            trigger: 'item',
            formatter: "{a} <br/>{b}: {c} ({d}%)",
    position:function(p){   //其中p为当前鼠标的位置
                return [p[0] + 10, p[1] - 10];
            }
        },
        legend: {
            
    top:'70%',
           itemWidth: 10,
            itemHeight: 10,
            data:['0岁以下','20-29岁','30-39岁','40-49岁','50岁以上'],
                    textStyle: {
                color: 'rgba(255,255,255,.5)',
                fontSize:'12',
            }
        },
        series: [
            {
                name:'年龄分布',
                type:'pie',
                center: ['50%', '42%'],
                radius: ['40%', '60%'],
                      color: ['#065aab', '#066eab', '#0682ab', '#0696ab', '#06a0ab','#06b4ab','#06c8ab','#06dcab','#06f0ab'],	
                label: {show:false},
                labelLine: {show:false},
                data:[
                    {value:1, name:'0岁以下'},
                    {value:4, name:'20-29岁'},
                    {value:2, name:'30-39岁'},
                    {value:2, name:'40-49岁'},
                    {value:1, name:'50岁以上'},
                ]
            }
        ]
    };
          
            // 使用刚指定的配置项和数据显示图表。
            myChart.setOption(option);
            window.addEventListener("resize",function(){
                myChart.resize();
            });
        },
     echarts_32() {
            // 基于准备好的dom，初始化echarts实例
            var myChart = echarts.init(document.getElementById('fb2'));
            var option = {
       
            title: [{
            text: '性别分布',
            left: 'center',
            textStyle: {
                color: '#fff',
                fontSize:'16'
            }
    
        }],
        tooltip: {
            trigger: 'item',
            formatter: "{a} <br/>{b}: {c} ({d}%)",
    position:function(p){   //其中p为当前鼠标的位置
                return [p[0] + 10, p[1] - 10];
            }
        },
        legend: {
            
        top:'70%',
           itemWidth: 10,
            itemHeight: 10,
            data:['男','女'],
                    textStyle: {
               color: 'rgba(255,255,255,.5)',
                fontSize:'12',
            }
        },
        series: [
            {
                name:'性别分布',
                type:'pie',
                center: ['50%', '42%'],
                radius: ['40%', '60%'],
                color: ['#065aab', '#066eab', '#0682ab', '#0696ab', '#06a0ab','#06b4ab','#06c8ab','#06dcab','#06f0ab'],	
                label: {show:false},
                labelLine: {show:false},
                data:[
                    {value:5, name:'男'},
                    {value:1, name:'女'},
    
    
                ]
            }
        ]
    };
          
            // 使用刚指定的配置项和数据显示图表。
            myChart.setOption(option);
            window.addEventListener("resize",function(){
                myChart.resize();
            });
        },
     echarts_33() {
            // 基于准备好的dom，初始化echarts实例
            var myChart = echarts.init(document.getElementById('fb3'));
            var option = {
            title: [{
            text: '口罩分布',
            left: 'center',
            textStyle: {
                color: '#fff',
                fontSize:'16'
            }
    
        }],
        tooltip: {
            trigger: 'item',
            formatter: "{a} <br/>{b}: {c} ({d}%)",
    position:function(p){   //其中p为当前鼠标的位置
                return [p[0] + 10, p[1] - 10];
            }
        },
        legend: {
        top:'70%',
           itemWidth: 10,
            itemHeight: 10,
            data:['带','未带'],
                    textStyle: {
                color: 'rgba(255,255,255,.5)',
                fontSize:'12',
            }
        },
        series: [
            {
                name:'口罩分布',
                type:'pie',
                center: ['50%', '42%'],
                radius: ['40%', '60%'],
                       color: ['#065aab', '#066eab', '#0682ab', '#0696ab', '#06a0ab','#06b4ab','#06c8ab','#06dcab','#06f0ab'],	
                label: {show:false},
                labelLine: {show:false},
                data:[
                    {value:2, name:'带'},
                    {value:3, name:'未带'},
    
                ]
            }
        ]
    };
            // 使用刚指定的配置项和数据显示图表。
            myChart.setOption(option);
            window.addEventListener("resize",function(){
                myChart.resize();
            });
        }    
    }
}
</script>

<style lang='scss' scoped>
 
</style>